import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { DynamicContent16, Snippet } from 'ui/icons';
import { spacing } from 'ui/theme';
import { selectFeatureFlags } from 'core/userContext';
import { DYNAMIC_CONTENT_BUILDER } from 'modules/dynamicContentBuilder/featureFlags';

import { OptOutDisclaimer } from '../OptOutDisclaimer';
import { useTranslations } from '../../hooks/useTranslations';
import { TextAreaFieldToolbarButton } from './TextAreaFieldToolbarButton';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

const OptOutWrapper = styled.div`
  padding: 0 ${spacing.threeQuarter};
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${spacing.quarter};
  margin: ${spacing.quarter} ${spacing.quarter};
`;

type TextAreaFieldToolbarProps = {
  hasSecondaryText?: boolean;
  onSnippetButtonClick: () => void;
  onDynamicContentButtonClick: () => void;
};

export const TextAreaFieldToolbar = ({
  hasSecondaryText,
  onSnippetButtonClick,
  onDynamicContentButtonClick,
}: TextAreaFieldToolbarProps) => {
  const { t } = useTranslations();
  const { [DYNAMIC_CONTENT_BUILDER]: canInsertDynamicContent } = useSelector(selectFeatureFlags);

  return (
    <Wrapper>
      {hasSecondaryText && (
        <OptOutWrapper>
          <OptOutDisclaimer />
        </OptOutWrapper>
      )}
      <ButtonGroup>
        <TextAreaFieldToolbarButton
          icon={<Snippet isColorInherited data-test="snippet-button" />}
          tooltip={t('input.textArea.actionInsertSnippet')}
          onClick={onSnippetButtonClick}
        />
        {canInsertDynamicContent && (
          <TextAreaFieldToolbarButton
            icon={<DynamicContent16 isColorInherited data-test="dynamic-content-button" />}
            tooltip={t('input.textArea.actionInsertDynamicContent')}
            onClick={onDynamicContentButtonClick}
          />
        )}
      </ButtonGroup>
    </Wrapper>
  );
};
